import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

const CatalogLinksEntityCard = EntityCardBlueprint.make({
  name: 'links',
  params: {
    filter: { 'metadata.links': { $exists: true } },
    loader: async () => import('./LinksCard').then(m => <m.LinksCard />),
    type: 'info',
  },
});

export const entityCards = [CatalogLinksEntityCard];
